import { Injectable } from '@angular/core';

export const OTP_RESEND_WAIT_SECONDS = 90;

export interface OtpContext {
  startPhone: string;
  lastPhone: string;
  otpDate: string;
  isOtpValidated?: boolean;
  checkpoint?: string;
}

const OTP_SESSION_KEY = 'otp_context';

@Injectable({
  providedIn: 'root',
})
export class OtpSessionService {
  saveOtpContext(response: Partial<OtpContext>): void {
    if (!response.startPhone || !response.lastPhone) {
      return;
    }

    const context: OtpContext = {
      startPhone: response.startPhone,
      lastPhone: response.lastPhone,
      otpDate: response.otpDate ?? new Date().toISOString(),
      isOtpValidated: response.isOtpValidated,
      checkpoint: response.checkpoint,
    };

    sessionStorage.setItem(OTP_SESSION_KEY, JSON.stringify(context));
  }

  getOtpContext(): OtpContext | null {
    const raw = sessionStorage.getItem(OTP_SESSION_KEY);
    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw) as OtpContext;
    } catch {
      this.clearOtpContext();
      return null;
    }
  }

  hasOtpContext(): boolean {
    return !!this.getOtpContext();
  }

  getRemainingResendSeconds(otpDate?: string): number {
    const date = otpDate ?? this.getOtpContext()?.otpDate;
    if (!date) {
      return 0;
    }

    const sentTime = new Date(date).getTime();
    if (Number.isNaN(sentTime)) {
      return 0;
    }

    const elapsedSeconds = Math.floor((Date.now() - sentTime) / 1000);
    return Math.max(0, OTP_RESEND_WAIT_SECONDS - elapsedSeconds);
  }

  canResendOtp(): boolean {
    return this.getRemainingResendSeconds() <= 0;
  }

  buildPhoneMessage(context?: OtpContext | null): string {
    const data = context ?? this.getOtpContext();
    if (!data) {
      return 'Se ha enviado el código de verificación a su celular.';
    }

    return `Se ha enviado el código de verificación a su celular ${data.startPhone}*****${data.lastPhone}`;
  }

  clearOtpContext(): void {
    sessionStorage.removeItem(OTP_SESSION_KEY);
  }
}
